module.exports = __webpack_public_path__ + "media/img/illustrations/icons/shift-type-roster-shift-f4a258e607096b3302e688c31da3af6c.svg";